import { connect } from 'react-redux';
import withImmutablePropsToJS from 'with-immutable-props-to-js';
import { Instances } from '../../../constants';
import { IStateType } from '../../../store/models/root.interface';
import { closeSideBar, getParams } from '../../../store/sidebar';
import {
    changeFilters, makeSelectInProgress, makeSelectObjectsArray, requestObjects
} from '../../../store/Objects';

import FilterModal, { MapDispatchToPropsType, MapStateToPropsType } from '../organisms/FilterModal';

const mapStateToProps = (state: IStateType) => {
    const params = getParams(state);
    const selectFlowLogsFilterFlowNames = makeSelectObjectsArray(Instances.FlowLogsFilterFlowNames);
    const selectFlowLogsFilterInProgress = makeSelectInProgress(Instances.FlowLogsFilterFlowNames);
    return {
        params,
        flowLogsFilterFlowNames: selectFlowLogsFilterFlowNames(state),
        flowLogsFilterInProgress: selectFlowLogsFilterInProgress(state),
    };
};

const mapDispatchToProps = {
    closeFilterModal: () => closeSideBar(),
    applyFilters: (filters: any) => changeFilters(Instances.Voicemail, filters),
    loadFlowLogsFilterFlowNames: (
        filters?: Record<string, any>,
    ) => requestObjects(Instances.FlowLogsFilterFlowNames, filters),
};

export default connect<MapStateToPropsType, MapDispatchToPropsType, unknown, IStateType>(
    mapStateToProps,
    mapDispatchToProps
)(withImmutablePropsToJS(FilterModal));